'use client';

import { Search } from '@benzinga/search-ui';
import type { Ticker } from '@benzinga/session';
import type { TrendingTopic } from '@benzinga/trending-topics-manager';
import classNames from 'classnames';
import styles from './TickerSearch.module.scss';

export interface TickerSearchProps {
  initialTrendingTickers?: Ticker[];
  initialTrendingTopics?: TrendingTopic[];
  placeholder?: string;
  block?: boolean;
  showBackdrop?: boolean;
  dropdownSuppressed?: boolean;
  onActivate?: () => void;
}

export const TickerSearch = ({
  initialTrendingTickers,
  initialTrendingTopics,
  placeholder = 'Search a ticker…',
  block = false,
  showBackdrop = true,
  dropdownSuppressed,
  onActivate,
}: TickerSearchProps) => (
  <div className={classNames(styles.search, block && styles.block)}>
    <Search
      variant="navbar"
      placeholder={placeholder}
      showBackdrop={showBackdrop}
      showTrending
      dropdownSuppressed={dropdownSuppressed}
      onActivate={onActivate}
      initialTrendingTickers={initialTrendingTickers}
      initialTrendingTopics={initialTrendingTopics}
    />
  </div>
);
